import {
    ChakraProvider
} from '@chakra-ui/react';
import { FormProvider } from 'components/FormGenerator/ContextProvider';
import {
    formComponents,
    viewComponents,
} from 'components/FormGenerator/FormGeno';
import Page from 'components/Page';
import appConfig from 'config/app';
import RootRouter from 'routes';
import theme from './theme';
// Web3 (WalletConnect/Tron) components are detached from the main program.
// Keep these imports commented out; restore them together with the providers
// below when Web3 deposit needs to be re-enabled.
// import {
//     ethereumClient,
//     projectId,
//     tronAdapters,
//     wagmiConfig,
// } from 'components/Web3/Web3Config';
// import {WagmiConfig} from 'wagmi';
// import {Web3Modal} from '@web3modal/react';
// import {WalletProvider} from '@tronweb3/tronwallet-adapter-react-hooks';

function App() {
    return (
        <ChakraProvider theme={theme}>
            <FormProvider
                formComponents={formComponents}
                viewComponents={viewComponents}
            >
                {/* <WalletProvider
                        onError={(e) => console.log(e)}
                        adapters={tronAdapters}
                        autoConnect={false}
                    >
                        <WagmiConfig config={wagmiConfig}> */}
                <Page ico={appConfig.ico}>
                    <RootRouter />
                </Page>
                {/* </WagmiConfig>
                    </WalletProvider> */}
                {/* <Web3Modal
                        projectId={projectId}
                        ethereumClient={ethereumClient}
                        themeVariables={{
                            '--w3m-font-family': `Inter, sans-serif`,
                        }}
                    /> */}
            </FormProvider>
        </ChakraProvider>
    );
}

export default App;
